import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { RangeSelectorComponent } from './range-selector.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    NgbModule
  ],
  declarations: [
    RangeSelectorComponent,
    DatepickerComponent
  ],
  exports: [RangeSelectorComponent]
})
export class RangeSelectorModule { }
